module.exports = "/_next/static/images/d0223ec8beafb928cd618a7dde4ac88b-product-information-xs-1x.jpg";